/* DEMO: builds the desktop dropdown layout from whatever is in each Shopify navigation menu, so new menu items arrange themselves.
   For every dropdown panel it makes a desktop-only copy of the sections (the original markup stays untouched for mobile) and sorts them:
   - sections with pictures  -> a tile grid (logos / product pictures)
   - sections with links     -> columns on the left
   - heading-only links      -> a tidy 'shop by' list on the right
   plus a 'View all <Category>' link and a strip identical to the top orange bar (free delivery, live next-dispatch countdown, Feefo). */
(function () {
  function titleCase(s) { return s.toLowerCase().replace(/(^|[\s&-])([a-z])/g, function (m, a, b) { return a + b.toUpperCase(); }); }
  var STAR = '<i class="fa fa-star" aria-hidden="true"></i>';
  var STRIP =
    '<a class="dc-bar-item" href="/pages/our-delivery"><i class="fa fa-truck" aria-hidden="true"></i> Free delivery <small>on orders over &pound;70</small></a>' +
    '<a class="dc-bar-item dc-timer" href="/pages/our-delivery"><span class="dc-timer-label">Next dispatch:</span> <span class="dc-timer-clock">--h --m --s</span></a>' +
    '<a class="dc-bar-item dc-feefo" href="/pages/discount-coffee-reviews" aria-label="Rated Excellent on Feefo"><span class="dc-fd">Excellent</span><span class="dc-fs">' + STAR + STAR + STAR + STAR + STAR + '</span><span class="dc-fw">feefo</span></a>';

  function cloneSection(s) {
    var c = s.cloneNode(true);
    c.removeAttribute('id');
    Array.prototype.forEach.call(c.querySelectorAll('[id]'), function (e) { e.removeAttribute('id'); });
    var hasImg = !!c.querySelector('img');
    var dd = c.querySelectorAll('dd').length;
    // Collection with no picture in Shopify: drop the grey placeholder and show a text tile instead
    Array.prototype.forEach.call(c.querySelectorAll('img'), function (img) {
      if (/no[-_ ]?image/i.test(img.getAttribute('src') || '')) {
        var a = img.closest('a');
        img.remove();
        c.classList.add('dc-noimg');
        if (a && !a.textContent.trim()) a.remove();
      }
    });
    if (!hasImg && dd === 0) c.classList.add('dc-linkonly');
    return { el: c, img: hasImg, dd: dd };
  }

  function build() {
    document.querySelectorAll('#main-nav .pulldown-menu-inner').forEach(function (nav) {
      if (nav.querySelector('.dc-dm')) return;
      var secs = Array.prototype.slice.call(nav.querySelectorAll('.pulldown-menu-nav-level-2'));
      var note = nav.querySelector('.dropdown-delevery-note');
      function put(el) { if (note) nav.insertBefore(el, note); else nav.appendChild(el); }

      if (secs.length) {
        var info = secs.map(cloneSection);
        var dm = document.createElement('div');
        dm.className = 'dc-dm';
        if (info.some(function (x) { return x.img; })) {
          dm.classList.add('dc-tiles');
          dm.style.setProperty('--cols', info.length <= 12 ? 6 : 8);
          info.forEach(function (x) { dm.appendChild(x.el); });
        } else {
          // Only when a menu has a really long list (12+ links, e.g. Syrup flavours) do the short sections move into the right-hand column
          var big = info.some(function (x) { return x.dd >= 12; });
          var side = info.filter(function (x) { return big ? x.dd <= 5 : x.dd === 0; });
          var main = info.filter(function (x) { return side.indexOf(x) < 0; });
          if (!main.length) { main = side; side = []; }
          var m = document.createElement('div');
          m.className = 'dc-dm-main';
          m.style.setProperty('--n', Math.min(main.length, side.length ? 4 : 5));
          main.forEach(function (x) { m.appendChild(x.el); });
          dm.appendChild(m);
          if (side.length) {
            var sd = document.createElement('div');
            sd.className = 'dc-dm-side';
            side.forEach(function (x) { sd.appendChild(x.el); });
            dm.appendChild(sd);
          }
        }
        put(dm);
      }

      var src = nav.querySelector('.pulldown-parent-page-header a');
      if (src) {
        var v = document.createElement('a');
        v.className = 'dc-viewall';
        v.href = src.getAttribute('href');
        v.textContent = 'View all ' + titleCase(src.textContent.replace(/\s+/g, ' ').trim());
        put(v);
      }
      var s = document.createElement('div');
      s.className = 'dc-reasons';
      s.innerHTML = STRIP;
      put(s);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build); else build();
})();
